import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { submitSiteRoadwaysROWThunk } from "./thunk/sideRoadwaysThunk";
import { QuestionsPayload } from "../types";

interface SiteRoadwaysROWFormState {
  loading: boolean;
  error: string | null;
  success: boolean;
  data: any;
  payloadSnapshot: any;

  application_id: string;
  utility_type: string;
  inputPayload: Record<string, any>;
  questions_true: number[];
  questions_false: number[];
}

const initialState: QuestionsPayload = {
  existing_duct_dimension_details: "",
  duct_utility_details: "",
  right_of_use: "",
  utilized_nh_land_area: "",
  proposed_utility_dimension: "",
  circle_rate: "",
  application_category: "",
  amenity: "",
  // available_row_length: "",
  available_row_width_left: "",
  available_row_width_right: "",
  proposed_utility_distance_left: "",
  proposed_utility_distance_right: "",
  land_acquisition_proposal_left: "",
  land_acquisition_proposal_right: "",
  total_land_to_be_acquired: null,
  utility_crossing_arrangement_id: null,
  // cable_laying_location: "",
  already_laid_services_desc: "",
  left_side_center_line: null,
  right_side_center_line: null,
  proposed_service_road_left: null,
  proposed_service_road_right: null,
  cable_position_within_right_of_way: "",
  // utility_service_depth_m: "",
  // crossing_compliance_status: "",
  // serviceroad_duct_approval_status: "",
  cable_encasement_type: "",
  utility_line_casing_type: "",
  casing_depth_meters: "",
  waterway_prevention_compliance: "",
  laying_methodology: "",
  trench_refilling_methodology: "",

  // trench_size: null,
  // number_of_proposed_lanes: null,
  number_of_existing_lanes: null,
  trench_width_over_pipe_cm: null,
  trench_bedding_depth_cm: null,
  side_fill_layer_thickness_cm: null,

  //if noc is approved
  ofc_damage_details: "",
  distance_from_duct_edge_within_corridor: "",
  // cable_laying_methodology: "",
  // hdd_compliance_status: "",
  distance_from_edge_within_corridor: null,
  // cable_duct_distance_from_trench_edge: 0,
  // distance_to_nearest_highway_structure: 0,

  questions_true: [],
  questions_false: [],


  //----------------


  // existing_utility_details: "",
  // selected_utility_duct: "",
  // utility_type: "",
  // applicant_agency_signatory_name: "",
  // distance_from_row_edge_gt_45m_m: 0,
  // distance_from_edge_no_acquisition_side_m: 0,
  // distance_from_row_edge_not_finalized_m: 0,
  // actual_trench_size_depth_m: 0,



};

const siteRoadwaysROWSlice = createSlice({
  name: "siteRoadwaysROW",
  initialState,
  reducers: {
    setSiteRoadwaysROWField: (
      state,
      action: PayloadAction<{
        name: keyof QuestionsPayload | string;
        value: any;
      }>
    ) => {
      (state as any)[action.payload.name] = action.payload.value;
    },
    setSiteRoadwaysROWMultipleFields: (
      state,
      action: PayloadAction<Partial<QuestionsPayload>>
    ) => {
      return { ...state, ...action.payload };
    },
    resetSiteRoadwaysROW(state) {
      Object.assign(state, initialState);
    },
  },
});

export const {
  setSiteRoadwaysROWField,
  resetSiteRoadwaysROW,
  setSiteRoadwaysROWMultipleFields,
} = siteRoadwaysROWSlice.actions;

export default siteRoadwaysROWSlice.reducer;
